import { authorize, deleteRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function deleteAccessRulesAPI(id) {
  const url = `${AWS_API_URL}/2n/access-rules/${id}`;
  return deleteRequest(url, await authorize());
}

